import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.css'],
})
export class BankTransferComponent implements OnInit {
  public cuentaAhorroBancolombia: string;
  public convenioBancolombia: string;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit() {
    this.cuentaAhorroBancolombia = this.data.cuentaBancolombia.value;
    this.convenioBancolombia = this.data.convenioBancolombia.value;
  }

  public closedModal() {
    this.dialog.closeAll();
  }
}
